import styled from 'styled-components';
import { gridSizes, weights } from 'utils/style';
import MiniForm from './MiniForm';

export default styled(MiniForm)`
  margin-top: ${gridSizes('L')};

  .reference {
    font-size: ${gridSizes('M')};
    color: var(--grey900);
    margin-top: 4px;
  }

  .form {
    border-left: solid 4px var(--grey300);
    padding: 0px ${gridSizes('S')};

    .help {
      font-family: Roboto;
      font-size: 14px;
      color: var(--grey700);
      .italic {
        font-style: italic;
      }
    }
  }

  button {
    border-radius: 4px;
    padding: 4px 1.6rem;
    height: inherit;
    font-weight: ${weights('medium')};
  }

  .info-wrapper {
    line-height: 1.2;
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    position: relative;

    &:hover {
      .edit {
        display: flex;
      }
    }

    .edit {
      cursor: pointer;
      position: absolute;
      justify-content: center;
      align-items: center;
      right: 0;
      color: var(--primary500);
      display: none;
      padding: 0;
      appearance: none;
      border: none;
      svg {
        margin-right: 4px;
      }

      .label {
        margin-left: ${gridSizes('S')};
      }
    }
  }

  .bottom {
    color: var(--grey700);
    button {
      background: transparent;
      border: none;
      height: inherit;
      padding: inherit;
      border-radius: inherit;
      font-weight: normal;
      color: var(--primary500);
    }

    .add-btn {
      display: flex;
      justify-content: flex-start;
      align-items: unset;

      .icon {
        color: var(--primary500);
        border: 1px solid var(--primary500);
        margin-right: 5px;
      }
    }

    &.grey {
      button {
        color: var(--grey700);
      }

      .icon {
        color: var(--grey700);
        border: 1px solid var(--grey700);
      }
    }
  }
`;
